import { useContext } from 'react'
import { Context as ThemingContext } from './Context'

const useTheming = () => {
  const theming = useContext(ThemingContext)
  return theming
}

export default useTheming
